export default {
    name: "ajout-contrat",
    components: {},
    props: [],
    data() {
        return {
            societe: {
                debut_contrat: null,
                fin_contrat: null,
                type_contrat: "",
                fichier_contrat: null,
            },
            files: [],
            loading: false,
            types_contrat: [],
            file_error: false,
            save_loading: false,
            btn_disable: false
        };
    },
    computed: {},
    mounted() {
        // recupération des types contrats
        this.$store
            .dispatch("getTypesContrats")
            .then((response) => (this.types_contrat = response));
    },
    methods: {
        handleFilesUpload() {
            let uploadedFiles = this.$refs.files.files;
            /**
            * Adds the uploaded file to the files array
            */
            this.files = [];

            for (var i = 0; i < uploadedFiles.length; i++) {
                this.files.push(uploadedFiles[i]);
            }
            this.societe.fichier_contrat = this.files[0];

            this.file_error = false;
        },
        async onSubmit() {
            this.save_loading = true
            this.btn_disable = true

            const isValid = await this.$refs.form.validate();

            if (!isValid) {
                this.save_loading = false
                this.btn_diable = false
                return;
            }

            if (this.files.length == 0) {
                this.file_error = true
                this.save_loading = false
                this.btn_diable = false
                return;
            }

            //control the dates
            let date_debut = this.dateFormatToSend(this.societe.debut_contrat)
            let date_fin = this.dateFormatToSend(this.societe.fin_contrat)
            if (date_fin.date < date_debut.date) {
                this.doErrorMsg("La date de debut doit précéder la date de fin de contrat")
                return;
            }

            this.societe.type_contrat = this.societe.type_contrat.id;

          
            this.societe.debut_contrat = date_debut.date_to_send
            this.societe.fin_contrat = date_fin.date_to_send

            let form_data = new FormData();
            for (let key in this.societe) {
                form_data.append(key, this.societe[key])
            }

            this.$store.dispatch("addContrat", { 'data': form_data, 'id': this.$route.params.id }).then((res) => {
                console.log(res)
                // après le rendu sur la page, faire disparaitre le modal
                this.doSuccessMsg("Le contrat a été ajouté avec succès");
                this.$refs.close_modal.click()

                this.save_loading = false
                this.btn_diable = false

            }, error => {
                this.save_loading = false
                this.btn_diable = false
                console.log(error)
            });
        },


        doSuccessMsg: function (msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function (msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },


        dateFormatToSend: function (given_date) {
            let date = new Date(given_date);
            let month = date.getMonth() + 1,
                day = date.getDate();

            if (month < 10) month = "0" + month;
            let date_to_send = `${date.getFullYear()}-${month}-${day}
                                    `;
            return { date: date, date_to_send: date_to_send };
        },
    },
};
